import React from 'react';
import { Table } from 'semantic-ui-react';
import SimpleTwoColumnTableRow from './SimpleTwoColumnTableRow';
import axios from 'axios';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;


// studentInfoPreviousEducations {}
export default class PreviousEducation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            previousEducations: []
        };
    }

    componentDidMount() {
        axios({
            method: 'get',
            url: this.props.studentId === null ? '/students/previous-educations' : `/students/${this.props.studentId}/previous-educations`
        })
            .then(res => {
                this.setState({ previousEducations: res.data });
            });
    }
    render() {
        const { previousEducations } = this.state;
        if (!previousEducations.length) return <div></div>;

        return (
            <Table celled size="small" unstackable compact>
                <Table.Header>
                    <Table.Row>
                    </Table.Row>
                </Table.Header>
                <Table.Body>{previousEducations.map(el =>
                    (<SimpleTwoColumnTableRow
                        name={el.institution.type ? el.institution.type.name.substring(0, 1).toUpperCase() + el.institution.type.name.substring(1) : ''}
                        keyName="institution"
                        value={el.institution.name}
                    />
                    ))}
                </Table.Body>
            </Table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentPersonalInfo/PreviousEducationTable.js